import { createSelector } from "reselect";
import { ApplicationStore } from "src/store";

export function getTradeInValue(state: ApplicationStore) {
    return state.tradeIn?.value?.[state.tradeIn.condition ?? "target"] || state.tradeIn?.customer_estimate || 0;
}

export function getTradeInMileage(state: ApplicationStore) {
    return state.tradeIn.odometer?.amount;
}

export const getYearMakeModelTrim = (state: ApplicationStore) => {
    const { tradeIn } = state;
    return [tradeIn?.year, tradeIn?.make, tradeIn?.model, tradeIn?.trim].filter(Boolean).join(" ");
};

export const isAccuTradeInstantCashOfferExpired = createSelector(
    (state: ApplicationStore) => state.tradeIn?.offer_expiration,
    (expiration) => !!(expiration && new Date(expiration) <= new Date())
);

export const getTradeInVin = (state: ApplicationStore) => {
    return state.tradeIn?.vin;
};

export const getAccuTradeIcoUuid = (state: ApplicationStore) => {
    return state.tradeIn?.offer_uuid;
};

export const hasActiveAccuTradeInstantCashOffer = createSelector(
    [(state: ApplicationStore) => state.tradeIn?.offer_uuid, isAccuTradeInstantCashOfferExpired],
    (icoUUID, icoOfferExpired) => !!icoUUID && !icoOfferExpired
);
